import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white,
        paddingTop: basePadding.paddingVertical
    },
    header: {
        paddingHorizontal: RFValue(4),
        paddingBottom: RFValue(4)
    },
    videosContent: {
        flex: 1
        // marginBottom: 50
    },
    contentContainer: { paddingBottom: 50, paddingTop: basePadding.paddingVertical },
    mediaContainer: {
        marginBottom: 18
    },
    mediaLabel: {
        paddingHorizontal: 25,
        paddingVertical: 10,
        borderRadius: 10,
        marginRight: 12,
        backgroundColor: baseColors.green.light
    },
    media: {
        flexDirection: "row",
        marginVertical: 18
    },
    clearFilter: {
        marginTop: 18,
        alignItems: "center"
    },
    clearFilterLabel: { color: baseColors.green.primary, textDecorationLine: "underline" },
    radioGroupContainer: { flexDirection: "row", marginVertical: RFValue(20) },
    radioContainer: {
        marginRight: RFValue(50)
    },
    radioContent: { flexDirection: "row", alignItems: "center" }
})

export default styles
